import { APIResponse, APIResponseDtoImpl } from '../../apiresponse';

export interface GenerateOTPResponse extends APIResponse 
{

}

export class GenerateOTPResponseDtoImpl extends APIResponseDtoImpl implements GenerateOTPResponse 
{
    
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/otp/generateotp/generateotpresponse.tsx